import React from 'react';
const links = [{
  label: 'Termini',
  href: '#termini'
}, {
  label: 'Privacy',
  href: '#privacy'
}, {
  label: 'Rimborsi',
  href: '#rimborsi'
}, {
  label: 'Contatti',
  href: '#contatti'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-171" data-mp="35crczxe406b8">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-172" data-mp="3a6c3z5hac00x">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-173" data-mp="3f6giwr2jomp1">
          Lash & Brow Instructor Ready™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-174" data-mp="3o5v53eboib3q">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-175" data-mp="3t1so5sebtvk7">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/50" data-id="element-176" data-mp="ojwlcbr04lc">
        © 2026 Lash & Brow Instructor Ready™ — Versione Italiana. Raccolta di materiali didattici digitali
        per formatrici Lash & Brow. Non fornisce qualifiche professionali né certificazioni ufficialmente
        riconosciute. Checkout sicuro — il pagamento viene elaborato nella tua valuta locale.
      </p>
    </footer>;
}